import React from "react";
import GoogleMapReact from "google-map-react";
import moment from "moment";

import { VehicleLocation } from "../../../../models";
import * as simpleMapStyle from "../../../Schedules/components/MapView/simpleStyle.json";

import "./DriverLocationMap.scss";

const DEFAULT_ZOOM = 13;

interface DriverMarkerProps {
  lat: number;
  lng: number;
  location: VehicleLocation;
  driverName?: string;
}

function freshnessLabel(location: VehicleLocation): string {
  const ts = location.gpsTime || location.fetchedAt;
  if (!ts) return location.stale ? "Location may be stale" : "";
  const rel = moment(ts).fromNow();
  return location.stale ? `Updated ${rel} (stale)` : `Updated ${rel}`;
}

function DriverMarker({ location, driverName }: DriverMarkerProps) {
  const [open, setOpen] = React.useState(false);
  const freshness = freshnessLabel(location);

  return (
    <div
      className={`driver-marker${location.stale ? " stale" : ""}`}
      data-testid="driver-marker"
    >
      <div
        className="pin"
        data-testid="driver-marker-pin"
        onClick={() => setOpen((o) => !o)}
      />
      {open && (
        <div className="popup">
          {driverName && <div className="popup-label">{driverName}</div>}
          <div className="popup-row">{location.address ?? "—"}</div>
          <div className="popup-row">
            {typeof location.speedMph === "number"
              ? `${Math.round(location.speedMph)} mph`
              : "—"}
          </div>
          {freshness && <div className="popup-row muted">{freshness}</div>}
        </div>
      )}
    </div>
  );
}

function isLocated(location?: VehicleLocation): location is VehicleLocation {
  return (
    !!location?.available &&
    typeof location.latitude === "number" &&
    typeof location.longitude === "number"
  );
}

export interface DriverLocationMapProps {
  location?: VehicleLocation;
  driverName?: string;
}

export function DriverLocationMap({ location, driverName }: DriverLocationMapProps) {
  const reason = location?.reason;
  if (!isLocated(location)) {
    const reasonText =
      reason === "no_schedule_today"
        ? "No vehicle assigned today"
        : "No live location available";
    return (
      <div className="driver-location-map-component" data-testid="driver-location-map">
        <div className="no-location" data-testid="driver-location-empty">
          {reasonText}
        </div>
      </div>
    );
  }

  const center = { lat: location.latitude as number, lng: location.longitude as number };

  return (
    <div className="driver-location-map-component" data-testid="driver-location-map">
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyCkRYkFYLEOcaEbwmSYJXaQ2jlIttKkl8M", version: "3.58.8" }}
        defaultCenter={center}
        center={center}
        defaultZoom={DEFAULT_ZOOM}
        options={{ styles: simpleMapStyle }}
      >
        <DriverMarker
          lat={center.lat}
          lng={center.lng}
          location={location}
          driverName={driverName}
        />
      </GoogleMapReact>
    </div>
  );
}
